<h2 mat-dialog-title class="mat-dialog-title-offset">Send learner feedback link@if (studentName != null && studentName != '') {
  <div class="tw:inline"> - ({{studentName}})</div>
}</h2>

<div class="modal-close-icon-container tw:flex tw:items-center">
  <button class="close-modal" mat-button [mat-dialog-close]="false" tabindex='-1'>
    <div class="close-modal modal-close-icon">
    </div>
  </button>
</div>

<mat-dialog-content class="mat-typography modal-master-container tw:mx-2">
  <div class="tw:w-full tw:p-4 tw:m-0 tw:mt-2 content-container">

    <div class="tw:flex tw:flex-wrap tw:-mx-[15px] tw:pb-6">

      <div class="tw:w-full tw:px-[15px] tw:mb-2">
        <label class="font-16"> Secure links to grant your learners safe access to the feedback form:</label>
      </div>

      @if (!generatedSuccessfully) {
        <div class="tw:w-full tw:px-[15px] tw:my-2">
          <div class="button-container">
            <button type="button" class="btn btn-primary tw:w-full" (click)="generateFeedbackLink()">Feedback Link</button>
          </div>
          <div class="description-container tw:pl-6">
            <label class="font-16">Generate a link to grant a learner one-time access</label>
          </div>
        </div>
      }

      <div class="tw:w-full tw:px-[15px] tw:mt-4">
        <div class="flex-row tw:px-0 tw:mx-0">
          <div class="flex-column tw:px-0 tw:mx-0">
            <label class="description-container">Send the link to the learner, who then simply clicks on it, and they will be taken to the feedback form.</label>
          </div>
        </div>

        <div class="flex-row tw:p-0 tw:m-0">
          <div class="flex-column tw:p-0 tw:m-0">
            <label class="url-link tw:mr-2" #linkLabel>{{studentFeedbackUrl}}</label>
            <div class="div-flex-buttons">
              <div class="tw:flex tw:flex-wrap tw:p-0 tw:m-0 tw:w-full">
                <div class="tw:w-full tw:p-0 tw:m-0">
                  <button type="button" class="btn btn-primary" style="width: 120px;" (click)="copyLink(linkLabel)">Copy Link</button>
                  <button type="button" class="btn btn-primary tw:ml-2" style="width: 120px;" (click)="openLink(linkLabel)">Open Link</button>
                  @if (showEmailButton) {
                    <button type="button" class="btn btn-primary tw:ml-2" style="width: 165px;" (click)="emailToStudent()">Email Link To Learner</button>
                  }
                </div>
              </div>
            </div>

          </div>
        </div>

        @if (hasEmailStudentAccessLinkPermission) {
          <div class="tw:flex tw:flex-wrap tw:p-0 tw:m-0 tw:mb-4 tw:mt-1 tw:pt-4">
            <div class="tw:flex-1 tw:p-0 tw:m-0">
              <label>Email link</label>
              <div class="input-group tw:mb-4">
                <input class="form-control" placeholder="enter email address to send link to" type="email"
                  (keydown.enter)="emailLink()" [(ngModel)]="emailAddress" email>
                  <div class="input-group-btn">
                    <button class="btn btn-primary" type="button" (click)="emailLink()">Send</button>
                  </div>
                </div>
                @if (showEmailRequiredError) {
                  <div>
                    <label class="tw:text-danger">Email address required</label>
                  </div>
                }
                @if (showEmailInvalidError) {
                  <div>
                    <label class="tw:text-danger">This is an invalid email address</label>
                  </div>
                }
              </div>
            </div>
          }
        </div>

      </div>
    </div>

  </mat-dialog-content>

  <mat-dialog-actions class="div-flex-buttons">
    <div class="tw:flex tw:flex-wrap tw:p-0 tw:m-0 tw:w-full">
      <div class="tw:w-full tw:p-0 tw:m-0">
        <button mat-button [mat-dialog-close]="false" class="btn btn-primary btn-sm tw:my-1 tw:mx-1 divclose tw:float-left">Close</button>
      </div>
    </div>
  </mat-dialog-actions>